const getEPA = (data) => ({
  method: "GET",
  url: "/proxy/epa",
  data,
});

const getCBS = (data) => ({
  method: "GET",
  url: "/proxy/cbs",
  data,
});

export const proxyApi = {
  getEPA,
  getCBS,
};
